import React from 'react'

function Error404() {
  return (
    <>
     <div className="page error-bg" id="particles-js">
        {/* <!-- Start::error-page --> */}
        <div className="main-error-wrapper page-h">
            <img src="assets/images/media/pngs/1.png" className="error-page-img" alt="error"/>
            <h2 className="title">Oopps. The page you were looking for doesn't exist.</h2>
            <h6 className="sub_title">You may have mistyped the address or the page may have moved.</h6><a className="btn btn-outline-danger" href="/">Back to Home</a>
        </div>
    </div>
    </>
  )
}

export default Error404